/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/magnific.js');

// export function popup() {
//   $('.popupLink').magnificPopup({
//     type: 'inline',
//     midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
//     gallery: {
//       enabled: true
//     }
//   });
// }

export function popupVideo() {
  // var videoSrc = $('.youtube-video').attr("src");
  // $('.popupLink').magnificPopup({
  //   type: 'inline',
  //   midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  //   // callbacks: {
  //   //   open: function() {
  //   //     var autoplay = videoSrc + '?autoplay=1&enablejsapi=1';
  //   //     $('.youtube-video').attr("src", autoplay);
  //   //   },
  //   //   close: function() {
  //   //     $('.youtube-video').attr("src", videoSrc);
  //   //   }
  //   // }
  // });

  $('.popupLink').on('click tap', function (e) {
    e.preventDefault();
    var videoID = $(this).attr('data-video-id');

    $.magnificPopup.open({
      items: {
        type: 'iframe',
        src: 'https://www.youtube-nocookie.com/embed/' + videoID + '?mute=1&autoplay=1&rel=0'
      },
      preloader: true
    });
    // alert(videoSrc);
  });
}
